<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">产品编号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.sd_prodcode }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">序号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.sd_detno }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">产品名称</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_detail }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">数量</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.sd_qty }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">型号</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_orispeccode }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">厂家/品牌</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_brand }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">产品规格</label>
          </div>
          <div class="weui-cell__bd">{{ itemData.productDTO.pr_spec }}</div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label for class="weui-label">变更原因</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.sd_remark"
              placeholder="请输入"
            />
          </div>
        </div>
      </div>

      <div class="weui-cells__group">
        <div class="weui-cells__title">
          <span>分拆{{ 1 }}</span>
        </div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">数量</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.sd_qty"
                placeholder="请填写"
              />
            </div>
          </div>
          <!-- <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">已转数</label>
            </div>
            <div class="weui-cell__bd">{{  }}</div>
          </div> -->
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">含税单价</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.sd_price"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">税率</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="form.sd_taxrate"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <date-field :label="'交货日期'" v-model="form.sd_delivery"/>
          <a
            href="javascript:"
            v-if="form.splitList.length == 0"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.splitList"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>分拆{{ xindex + 2 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">数量</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.ps_qty"
                placeholder="请填写"
              />
            </div>
          </div>
          <!-- <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">已转数</label>
            </div>
            <div class="weui-cell__bd">{{  }}</div>
          </div> -->
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">含税单价</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.ps_price"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">税率</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.ps_taxrate"
                @change="calcItem"
                placeholder="请填写"
              />
            </div>
          </div>
          <date-field :label="'交货日期'" v-model="item.ps_delivery"/>
          <a
            href="javascript:"
            v-if="xindex == form.splitList.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="onsave"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    DateField
  },
  mixins: [process],
  props: {
    itemData: Object,
  },
  data() {
    return {
      baseUrl: "/api/sale/sale/modifyDetail",
      codeField: "sc_code",
      statusField: "sc_statuscode",
      caller: "SaleChange",
      xtype: "sale-change-formpanel",
      form: {
        id: null,
        sd_qty: 0,
        sd_delivery: "",
        sd_taxrate: 13,
        sd_price: 0,
        sd_netprice: 0,
        sd_remark: "",
        splitList: [
          // {
          //   from_change_split_id: '',
          //   ps_delivery: '',
          //   ps_netprice: 0,
          //   ps_price: 0,
          //   ps_qty: 0,
          //   ps_taxrate: 0
          // }
        ]
      }
    };
  },
  mounted() {
    if (this.itemData) {
      let { form, itemData } = this
      form.id = itemData.id
      form.sd_qty = itemData.sd_qty
      form.sd_delivery = itemData.sd_delivery
      form.sd_price = itemData.sd_price
    }
  },
  methods: {
    calcItem() {
      var me = this,
        form = me.form,
        splitList = form.splitList;

      form.sd_netprice = me.$number.round(form.sd_price / (1 + form.sd_taxrate / 100), 6);

      splitList.forEach((item) => {
        item.ps_netprice = me.$number.round(item.ps_price / (1 + item.ps_taxrate / 100), 6);
      });
    },
    onsave() {
      var me = this,
        form = me.form,
        splitList = form.splitList,
        total = 0,
        checked;
      if (!form.sd_remark) {
        me.$weui.topTips("请填写变更原因", 2000);
        return
      } else if (!form.sd_qty) {
        me.$weui.topTips("分拆1的数量未填写", 2000);
        return
      } else if (!form.sd_delivery) {
        me.$weui.topTips("分拆1的日期未填写", 2000);
        return
      } else {
        var count = 0
        total += Number(form.sd_qty)
        splitList.forEach(function (item) {
          if (!item.ps_qty) {
            me.$weui.topTips(`分拆${count + 2}的数量未填写`, 2000);
            return false;
          } else if (!item.ps_delivery) {
            me.$weui.topTips(`分拆${count + 2}的日期未填写`, 2000);
            return false;
          } else {
            count++
            // 合计
            total += Number(item.ps_qty)
          }
        });
        
        checked = count == splitList.length

        if (checked) {  
          if(total != me.itemData.sd_qty) {
            me.$weui.topTips(`分拆数量错误`, 2000);
            return
          }
          me.doModify();
        }

      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      this.form.splitList.splice(index, 1);
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        splitList = me.form.splitList;
      splitList.push({
        from_change_split_id: '',
        ps_delivery: '',
        ps_netprice: 0,
        ps_price: 0,
        ps_qty: 0,
        ps_taxrate: 0
      });
    },
    doModify() {
      var me = this;
      me.$loading({
        url: '/api/sale/sale/modifyDetail',
        method: 'POST',
        jsonData: me.form
      }).then(function (res) {
        if(res.success) {
          me.preLaunchProcess(
            me.caller,
            res.data.change,
            me.xtype,
            function () {
              me.$router.back();
            }
          )
        } else {
          me.$weui.topTips(res.message || '变更失败', 2000);
        }
      }).catch(function () {
        me.$weui.topTips('变更失败', 2000);
      });
    }
  },
};
</script>